import { render, staticRenderFns } from "./ModalInventory.vue?vue&type=template&id=decd2188&scoped=true&"
import script from "./ModalInventory.vue?vue&type=script&lang=js&"
export * from "./ModalInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decd2188",
  null
  
)

export default component.exports